import React, { useState } from "react";
import { Typography, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from "@mui/material";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DensityLargeOutlined, DisplaySettingsSharp } from "@mui/icons-material";

const ItemTypes = {
  RECTANGLE: "rectangle",
};

const initialData = [
  {
    "id": 0,
    "text": "Section 4-15 of ITAA97",
    "correctMatch": "Taxable income = Assessable income − Allowable Deductions"
  },
  {
    "id": 1,
    "text": "Section 6-5(1) of ITAA97",
    "correctMatch": "Ordinary Income - Assessable income includes income according to ordinary concepts"
  },
  {
    "id": 2,
    "text": "Section 6-10 of ITAA97",
    "correctMatch": "Statutory income - Amounts that are not ordinary income under s.6-5, may still be included in assessable income by another provision"
  },
  {
    "id": 3,
    "text": "Section 21A of ITAA36",
    "correctMatch": "Arm's length value of non-cash business benefits will be included in assessable income of the taxpayer"
  },
  {
    "id": 4,
    "text": "Section 6-1(3)of ITAA97",
    "correctMatch": "Exempt income is not assessable"
  },
  {
    "id": 5,
    "text": "Section 6-5(4) of ITAA97",
    "correctMatch": "Derivation - Assessable income is included in taxable income in the year it is derived"
  },
  {
    "id": 6,
    "text": "Section 8-1 of ITAA97",
    "correctMatch": "General deductions - (1) You can deduct from your assessable income any loss or outgoing to the extent that: (a) it is incurred in gaining or producing your assessable income; or (b) it is necessarily incurred in carrying on a *business for the purpose of gaining or producing your assessable income."
  },
  {
    "id": 7,
    "text": "Section 8-5 of ITAA97",
    "correctMatch": "Specific deductions - a taxpayer can deduct an amount from their assessable income if there is a provision of ITAA 1997 which allows such an amount to be deducted"
  },
  {
    "id": 8,
    "text": "Section 25-10 of ITAA97",
    "correctMatch": "Repairs - allows an immediate deduction for expenditure you incur to repair premises or plant which you hold or use for the sole purpose of producing assessable income"
  },
  {
    "id": 9,
    "text": "Section 25-35 of ITAA97",
    "correctMatch": "Bad debts - You can deduct a debt (or part of a debt) that you write off as bad in the income year if: (a) it was included in your assessable income for the income year or for an earlier income year; or (b) it is in respect of money that you lent in the ordinary course of your * business of lending money."
  },
  {
    "id": 10,
    "text": "Section 36-15 of ITAA97",
    "correctMatch": "Tax losses for entities other than corporate tax entities - if your total assessable income for the later income year exceeds your total deductions (other than tax losses), you deduct the tax loss from that excess"
  },
  {
    "id": 11,
    "text": "Section 25-25 of ITAA97",
    "correctMatch": "Borrowing expenses - allows a deduction for expenditure incurred in borrowing money to the extent that the money is used for the purpose of producing assessable income."
  },
  {
    "id": 12,
    "text": "Division 35 of ITAA97",
    "correctMatch": "Non-commercial losses - prevents losses of individuals from non-commercial business activities being offset against other assessable income in the year the loss is incurred"
  },
  {
    "id": 13,
    "text": "Division 40 of ITAA97",
    "correctMatch": "Capital allowance - allows a taxpayer a deduction for the decline in the value of a “depreciating asset” that is owned and used by a taxpayer in the course of gaining or producing assessable income"
  },
  {
    "id": 14,
    "text": "Section 40-880 of ITAA97",
    "correctMatch": "Blackhole expenditure - to make certain * business capital expenditure deductible over 5 years, or immediately in the case of some start-up expenses for small businesses, if: (a) the expenditure is not otherwise taken into account; and (b) a deduction is not denied by some other provision; and (c) the business is, was or is proposed to be carried on for a * taxable purpose."
  },
  {
    "id": 15,
    "text": "Division 43 of ITAA97",
    "correctMatch": "Capital works - allows a taxpayer to claim a deduction for capital works expenditure incurred on the original construction cost of income-producing buildings and other capital works"
  }
]


function DraggableRectangle({ id, text, correctMatch}) {
  const [{ isDragging }, drag] = useDrag(() => ({
	type: ItemTypes.RECTANGLE,
	item: { id, text, correctMatch },
	collect: (monitor) => ({
	  isDragging: !!monitor.isDragging(),
	}),
  }));

  return (
	<div
	  ref={drag}
	  style={{
		opacity: isDragging ? 0.5 : 1,
		padding: "8px",
		margin: "4px",
		backgroundColor: "lightblue",
		cursor: "move",
		border: "1px solid black",
		borderRadius: "4px",
	  }}
	>
	  {correctMatch}
	</div>
  );
}

function DroppableCell({ rowId, onDrop, children }) {
  const [{ isOver }, drop] = useDrop(() => ({
	accept: ItemTypes.RECTANGLE,
	drop: (item) => onDrop(rowId, item),
	collect: (monitor) => ({
	  isOver: !!monitor.isOver(),
	}),
  }));

  return (
	<TableCell
	  ref={drop}
	  style={{
		minHeight: "50px",
		backgroundColor: isOver ? "lightgreen" : "white",
		border: "1px solid black",
	  }}
	>
	  {children}
	</TableCell>
  );
}

export default function Legislation() {

  const [matches, setMatches] = useState( () => new Array(16).fill(null));

  const handleDrop = (rowId, item) => {
    
    setMatches((previousMatces) => {
        console.log("dropping", previousMatces, item)
        let currentMatches = [...previousMatces];

        const foundIndex = currentMatches.findIndex( o => o?.id === item.id);

        console.log(foundIndex)
        if(foundIndex !== -1)
            currentMatches[foundIndex] = null;
        
        currentMatches[rowId] = item
        console.log("TRUTH TEST ", currentMatches)
        return [...currentMatches]
    })
};

  const checkAnswers = () => {
    let correctCount = 0;
    initialData.forEach((row) => {
      if (matches[row.id]?.id === row.id) {
        correctCount++;
      }
    });
    alert(`You matched ${correctCount} out of ${initialData.length} correctly.`);
  };

  const data = initialData.filter(x => !matches.some(m => m?.id === x.id));
  
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h4" align="center">
          Drag and Drop Exercise
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Law</TableCell>
                <TableCell>Definition</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {initialData.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>{row.text}</TableCell>
                  <DroppableCell key={row.id} rowId={row.id} onDrop={handleDrop}>
                    {matches[row.id] && (
                      <DraggableRectangle
                        key={matches[row.id].id}
                        id={matches[row.id].id}
                        text={matches[row.id].text}
                        correctMatch={matches[row.id].correctMatch} 
                      />
                    )}
                  </DroppableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography variant="h6">Drag these definitions:</Typography>
        <div>
          {data.map((rect) => (
            rect &&
            <DraggableRectangle key={rect.id} id={rect.id} text={rect.text} correctMatch={rect.correctMatch} />
          ))}
        </div>
      </Grid>
      <Grid item xs={12}>
        <Button variant="contained" color="primary" onClick={checkAnswers}>
          Check Answers
        </Button>
      </Grid>
    </Grid>
  );
}